import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Tabs, Tab, Box, Container, Paper, useTheme } from "@mui/material";
// import Events from "./Events";
// import Blogs from "./Blogs/Blogs";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getAllEvents,
  getExplore,
  getFeeds,
  getMyFeeds,
  getRegisteredAttendees,
} from "../../../../Redux/Reducers/communityReducer";
import FeedScreen from "../Feeds/FeedScreen";
import EventScreen from "../Events/EventScreen";
import BlogScreen from "../Blogs/BlogScreen";
import ExploreFeeds from "../Explore/ExploreFeeds";
import { useLocation, useNavigate } from "react-router-dom";
// Create placeholder components for each tab
// const Explore = () => <div>Explore Content</div>;
// const Feeds = () => <div>Feeds Content</div>;
// const Communities = () => <div>Communities Content</div>;
// const Events = () => <div>Events Content</div>;

const CommunityGlobalTabs = () => {
  const location = useLocation();
  const navigate = useNavigate(); // <-- Add this
  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab");
  const [currentTab, setCurrentTab] = useState(tabFromUrl || "first");
  const contentRef = useRef(null);
  const theme = useTheme();
  const dispatch = useDispatch();
  const myFeeds = useSelector((state) => state?.community?.myFeeds);
  const exploreType = useSelector((state) => state?.community?.exploreType);

  useEffect(() => {
    const payload = { type: exploreType, my_posts: false };
    dispatch(getFeeds(payload));
    dispatch(getAllEvents({ page: 0, type:exploreType }));
    dispatch(getExplore({ type: exploreType }));
    dispatch(getMyFeeds({ type: exploreType }));
    dispatch(getRegisteredAttendees({ type: exploreType }));
  }, [dispatch]);

   useEffect(() => {
    if (tabFromUrl && tabFromUrl !== currentTab) {
      setCurrentTab(tabFromUrl);
      // if (contentRef.current) contentRef.current.scrollTop = 0;
    }
  }, [tabFromUrl, currentTab]);

  const routes = useMemo(
    () => [
      { key: "first", title: "All", component: <ExploreFeeds /> },
      { key: "second", title: "Posts", component: <FeedScreen /> },
      { key: "fourth", title: "Events", component: <EventScreen /> },
      // { key: "fifth", title: "Blogs", component: <BlogScreen /> },
    ],
    []
  );

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    navigate(`/community?tab=${newValue}`)
    // if (contentRef.acurrent) contentRef.current.scrollTop = 0;
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // Load more data here
      // Example: fetchMoreData();
    }
  };

  return (
    // <Container maxWidth="lg">
    <Box sx={{ width: "100%" }}>
     <Paper
  elevation={1}
  sx={{
    borderRadius: 1,
    backgroundColor: "#fff",
    mb: 1,
    overflow: "hidden",
    overflowX: "auto",
  }}
>
  <Tabs
    value={currentTab}
    onChange={handleTabChange}
    variant="scrollable" // Keep scrollable if tabs overflow
    scrollButtons="auto"
    aria-label="Navigation tabs"
    TabIndicatorProps={{
      style: {
        height: 4,
        borderRadius: 2,
        backgroundColor: theme?.palette?.primary?.main,
      },
    }}
    sx={{
      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },
    }}
  >
    {routes?.map((route) => (
      <Tab
        key={route?.key}
        label={route?.title}
        value={route?.key}
        sx={{
          textTransform: "none",
          fontWeight: currentTab === route?.key ? "bold" : 500,
          color:
            currentTab === route?.key
              ? theme?.palette?.primary?.main
              : "#0044C6",
          fontSize: 16,
          px: 2,
        }}
      />
    ))}
  </Tabs>
</Paper>
      <Box
        ref={contentRef}
        sx={{
          height: "70vh", // Adjust as needed
          overflowY: "scroll",
          scrollbarWidth: "none",
          backgroundColor: "#F4F7FE",
        }}
        onScroll={handleScroll}
      >
        {routes?.map((route) => (
          <TabPanel
            key={route?.key}
            value={route?.key}
            currentTab={currentTab}
            padding={0}
          >
            {route?.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
    // </Container>
  );
};

// Tab panel component
function TabPanel(props) {
  const { children, value, currentTab, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== currentTab}
      id={`tabpanel-${value}`}
      aria-labelledby={`tab-${value}`}
      {...other}
    >
      {value === currentTab && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

export default CommunityGlobalTabs;
